module.exports = __webpack_public_path__ + "static/media/gov_leader_list-new.8c4ecc95.jpg";